import { render } from "./ApiDoc.vue?vue&type=template&id=6cb3bb74"
import script from "./ApiDoc.vue?vue&type=script&lang=js"
export * from "./ApiDoc.vue?vue&type=script&lang=js"

import "./ApiDoc.vue?vue&type=style&index=0&id=6cb3bb74&lang=css"

import exportComponent from "/codebuild/output/src2517490718/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__